"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsefulAddressService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const services_1 = require("../../../rest/services");
const usefulAddress_1 = require("../usefulAddress");
class UsefulAddressService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.getUsefulAddressFilters = (variables = {}, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(usefulAddress_1.usefulAddressFilters, variables, options, requestOptions);
      return response.data.usefulAddress.filtersList;
    });
    this.getUsefulAddressList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(usefulAddress_1.usefulAddressList, variables, options, requestOptions);
      return response.data.usefulAddress.list;
    });
    this.getMapUsefulAddressList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(usefulAddress_1.mapUsefulAddressList, variables, options, requestOptions);
      return response.data.usefulAddress.list;
    });
    this.getUsefulAddress = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(usefulAddress_1.usefulAddress, variables, options, requestOptions);
      return response.data.usefulAddress.address;
    });
    this.getUsefulAddressReviews = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(usefulAddress_1.usefulAddressReviews, variables, options, requestOptions);
      return response.data.usefulAddress.reviews;
    });
    this.createUsefulAddress = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.usefulAddressCreate, variables, options, requestOptions);
      return response.data.usefulAddress.create;
    });
    this.editUsefulAddress = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.usefulAddressEdit, variables, options, requestOptions);
      return response.data.usefulAddress.edit;
    });
    this.deleteUsefulAddress = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.usefulAddressDelete, variables, options, requestOptions);
      return response.data.usefulAddress.delete;
    });
    this.createAddressReview = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.addressReviewCreate, variables, options, requestOptions);
      return response.data.usefulAddress.review.create;
    });
    this.editAddressReview = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.addressReviewEdit, variables, options, requestOptions);
      return response.data.usefulAddress.review.edit;
    });
    this.deleteAddressReview = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.addressReviewDelete, variables, options, requestOptions);
      return response.data.usefulAddress.review.delete;
    });
    this.setFavoriteAddress = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(usefulAddress_1.addressFavoriteToggle, variables, options, requestOptions);
      return response.data.usefulAddress.setFavorite;
    });
    this.getAddressesPageHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(usefulAddress_1.usefulAddressHistory, variables, options, requestOptions);
      return response.data.usefulAddress.history;
    });
    this.fetchAddresses = (text, fiasId = '') => __awaiter(this, void 0, void 0, function* () {
      return yield services_1.dadataService.searchUsefulAddress(text, 10, fiasId);
    });
  }
}
exports.UsefulAddressService = UsefulAddressService;
const usefulAddressService = new UsefulAddressService();
exports.default = usefulAddressService;